// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__kKEW0","header":"Header_header__HXQOm","title":"Header_title__x3ga3","line":"Header_line__Nl0pD","paragraph":"Header_paragraph__iQARm"};